export default __webpack_public_path__ + "static/media/Comp 2_00015.9f51e29e.png";